import {
	IHelpItem
} from "modules/types";
import { createAction } from "redux-act";


export const fetchPrizes = createAction();
export const fetchPrizesSuccess = createAction<IHelpItem[]>();
export const fetchPrizesFailed = createAction();
